/**
 *
 *
 *
 *
 *
 *
 *
 *
 */
import { eventSync, type EventSync } from "../globals/event.js";


export * from "../lib/event/index.js";

/*                                               */
/*                                             */
/*                                          */
/*                                          */

/**
 *
 *
 *
 */
export const event: EventSync = eventSync;

/**
 *
 *
 *
 */
export const delegate: EventSync["delegate"] = event.delegate;

/**
 *
 *
 *
 */
export const stop: EventSync["stop"] = event.stop;

/**
 *
 *
 *
 */
export const undelegate: EventSync["undelegate"] = event.undelegate;

/**
 *
 *
 *
 */
export const on: EventSync["on"] = event.on;

/**
 *
 *
 *
 */
export const withEvents: EventSync["withEvents"] = event.withEvents;

/**
 *
 *
 *
 */
export const unsetAll: EventSync["unsetAll"] = event.unsetAll;